import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminNavbar from "./AdminNavbar";
import ImageWithLoader from "./ImageWithLoader"; // ⬅️ import added

function AdminCollections() {
    const [heading, setHeading] = useState("");
    const [image, setImage] = useState(null);
    const [collections, setCollections] = useState([]);

    const [editingId, setEditingId] = useState(null);
    const [editHeading, setEditHeading] = useState("");
    const [editImage, setEditImage] = useState(null);

    const fetchCollections = async () => {
        try {
            const res = await axios.get("https://himchatterjee.in/backend/collections.php");
            setCollections(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchCollections();
    }, []);

    // Add new collection
    const handleUpload = async (e) => {
        e.preventDefault();
        if (!heading.trim() || !image) return alert("Please add heading and select image");

        const formData = new FormData();
        formData.append("heading", heading);
        formData.append("image", image);

        try {
            const res = await axios.post("https://himchatterjee.in/backend/collections.php", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            alert(res.data.message);
            setHeading(""); setImage(null); fetchCollections();
        } catch (err) { console.error(err); }
    };

    // Start editing
    const startEdit = (c) => {
        setEditingId(c.id);
        setEditHeading(c.heading);
        setEditImage(null);
    };

    // Submit edit
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!editHeading.trim()) return alert("Heading required");

        const formData = new FormData();
        formData.append("heading", editHeading);
        formData.append("id", editingId);
        if (editImage) formData.append("image", editImage);

        try {
            const res = await axios.post("https://himchatterjee.in/backend/collections.php", formData);
            alert(res.data.message);
            setEditingId(null); setEditHeading(""); setEditImage(null);
            fetchCollections();
        } catch (err) { console.error(err); }
    };

    // Delete
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure?")) return;
        try {
            await axios.delete("https://himchatterjee.in/backend/collections.php", { data: { id } });
            fetchCollections();
        } catch (err) { console.error(err); }
    };

    return (
        <>
            <AdminNavbar />
            <div style={{ maxWidth: "800px", margin: "20px auto" }}>
                <h2>Admin Collections</h2>

                {/* Add New Collection */}
                {!editingId && (
                    <form onSubmit={handleUpload} style={{ marginBottom: "20px" }}>
                        <input type="text" placeholder="Enter Heading" value={heading} onChange={(e) => setHeading(e.target.value)} style={{ padding: "8px", width: "60%", marginRight: "10px" }} />
                        <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
                        <button type="submit" style={{ padding: "8px 16px", marginLeft: "10px" }}>Add</button>
                    </form>
                )}

                {/* Edit Collection */}
                {editingId && (
                    <form onSubmit={handleEditSubmit} style={{ marginBottom: "20px", border: "1px solid #ccc", padding: "10px", borderRadius: "6px" }}>
                        <h3>Edit Collection</h3>
                        <input type="text" value={editHeading} onChange={(e) => setEditHeading(e.target.value)} style={{ padding: "6px", width: "60%", marginRight: "10px" }} />
                        <input type="file" onChange={(e) => setEditImage(e.target.files[0])} />
                        <button type="submit" style={{ padding: "6px 12px", marginLeft: "10px" }}>Update</button>
                        <button type="button" onClick={() => setEditingId(null)} style={{ padding: "6px 12px", marginLeft: "10px" }}>Cancel</button>
                    </form>
                )}

                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>ID</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Heading</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Image</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Created At</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {collections.map((c) => (
                            <tr key={c.id}>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{c.id}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{c.heading}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                    <ImageWithLoader
                                        src={c.file_path}
                                        alt={c.heading}
                                        width={100}
                                        height={100}
                                    />
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{c.created_at}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                    <button onClick={() => startEdit(c)} style={{ padding: "6px 12px", background: "blue", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", marginRight: "5px" }}>Edit</button>
                                    <button onClick={() => handleDelete(c.id)} style={{ padding: "6px 12px", background: "red", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default AdminCollections;
